import type { ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import useSidebarContext from "@/v2-backoffice-client/components/sidebar/sidebar.context"
import type { SidebarItemVisualProps } from "@/v2-backoffice-client/components/sidebar/sidebar.item.constants"

export type SidebarItemContentProps = Pick<
  SidebarItemVisualProps,
  "isLoading" | "isChildrenHiddenOnMini" | "iconSrc" | "iconClassName" | "badge"
> & {
  children?: ReactNode
}

// Inner markup of a sidebar entry, shared by both of its element forms
// (SidebarLink's anchor, SidebarItem's button) so the two stay identical.
function SidebarItemContent(props: SidebarItemContentProps) {
  const {
    isLoading,
    isChildrenHiddenOnMini = true,
    iconSrc,
    iconClassName,
    badge,
    children,
  } = props

  const { isMini } = useSidebarContext()

  return (
    <>
      {(isLoading || iconSrc) && (
        <Icon
          src={iconSrc}
          loading={isLoading}
          className={cn("sidebar-item-icn", iconClassName, {
            "is-mini": isMini,
          })}
        />
      )}

      {isMini && isChildrenHiddenOnMini ? null : children}

      {badge != null && (
        <span className={cn("sidebar-item-badge", { "is-mini": isMini })}>
          {badge}
        </span>
      )}
    </>
  )
}

export default SidebarItemContent
